import React, { useEffect } from 'react';
import './chat.scss';
import { useHistory, useParams } from 'react-router';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import PropTypes from 'prop-types';
import ChatHeader from './ChatHeader';
import ConversationsHeader from './ConversationsHeader';
import ChatControls from './ChatControls';
import ChatSelector from './ChatSelector';
import ChatMessages from './ChatMessages';
import chatStorage from './chatStorage';
import ContactsList from './components/ContactsList';
import appState from '../../storages/mobx/appState';
import NotificationStatus from '../../components/NotificationStatus';

function ChatMain({ t }) {
  let interval = null;
  const { userId } = useParams();
  const history = useHistory();

  console.log('userId', userId, chatStorage.currentChatID);
  useEffect(() => {
    chatStorage
      .loadConversations()
      .then(() => {
        runInAction(() => {
          console.log('userId', chatStorage.conversations.find((c) => c.id === userId));
          if (userId) {
            chatStorage.changeCurrentChat(userId);
            history.replace('/app/channels');
          } else {
            chatStorage.changeCurrentChat(chatStorage.conversations[0].id);
          }
        });
      });
    if (interval == null) {
      interval = setInterval(() => {
        if (!chatStorage.inProgress) chatStorage.loadConversations();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <div className="chat flex-row">
        <div className="users-list flex-config">
          <ConversationsHeader />
          <ChatSelector />
        </div>
        <div className="chat-container flex-config">
          {chatStorage.currentChat?.id ? (
            <div className="area-content">
              <ChatHeader />
              <div className="flex-config area-content-messages-container">
                <ChatMessages />
              </div>

            </div>
          ) : (
            <div className="area-content flex justify-content-center align-items-center">
              {chatStorage.conversations.length > 0 ? t('Chat not found') : null}
            </div>
          )}
          <ChatControls disabled={!chatStorage.currentChat?.id} />

        </div>
        <div className="users-list chat-userinfo flex-config">
          {/* User info */}
          {/* <div> */}
          {/*  Свиридов Николай */}
          {/* </div> */}
          <ContactsList />
          <div>
            <ul>
              <li />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

ChatMain.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(observer(ChatMain));
